/* global axios */

const getBaseUrl = accountId =>
  `/api/v1/accounts/${accountId}/whatsapp_templates`;

export default {
  list(accountId, inboxId, params = {}) {
    return axios.get(getBaseUrl(accountId), {
      params: { inbox_id: inboxId, ...params },
    });
  },

  create(accountId, inboxId, templateData, mediaFile = null) {
    // Header de mídia: envia multipart (template como JSON + arquivo). O backend
    // faz o resumable upload na Meta e gera o header_handle. Sem mídia: JSON normal.
    if (mediaFile) {
      const form = new FormData();
      form.append('inbox_id', inboxId);
      form.append('template', JSON.stringify(templateData));
      form.append('header_media', mediaFile);
      return axios.post(getBaseUrl(accountId), form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return axios.post(getBaseUrl(accountId), {
      inbox_id: inboxId,
      template: templateData,
    });
  },

  destroy(accountId, inboxId, templateName) {
    return axios.delete(`${getBaseUrl(accountId)}/${templateName}`, {
      params: { inbox_id: inboxId },
    });
  },

  sync(accountId, inboxId) {
    return axios.post(`${getBaseUrl(accountId)}/sync`, {
      inbox_id: inboxId,
    });
  },
};
